import { render } from "./ApprovalQueue.vue?vue&type=template&id=382102a8"
import script from "./ApprovalQueue.vue?vue&type=script&lang=js"
export * from "./ApprovalQueue.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__